import { format } from '@appd/uik';
import { get } from 'lodash';
/**
 * Formats a value according to uik's format rules
 * @param dataType determins what format method to use {@link format} (e.g. number)
 * @param formatType determines what method from dataType to use (e.g. short)
 * @param value value to be formatted
 * @param options customizations for formatting
 * @returns formatted value
 */
export const toFormat = (dataType: string, formatType: string, value: any, options: Record<string, any> = {}) =>
  get(format, `${dataType}.${formatType}`, (v: any, _?: any) => v)(value, options);
